import { Component, Injectable } from '@angular/core';
import { CodeSnippet } from './code-snippet.interface';
import { ScriptMode } from '../enums';


@Component({
    selector: 'add-datapoint-snippet',
    template: '',
    standalone: false
})
export class AddAlarmMainLoopSnippet implements CodeSnippet{

    text: string = $localize`:@@script-editor.snippet.alarm-main:alarm-main()`;

    static category: string = 'climatix';

    data: any;

    part = true;

    static filter = [
        ScriptMode.alarmAction
    ];

    insert(): string | Promise<string> {
        return `-- this function is called when alarms are being processed
function alarmmain()

�    -- place your code here. try 'Process Alarms'�

end
`
    }
}